
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import videoCall from '@/components/videoCall/index.vue';

@Component({
  name: 'VideoCall',
  components: { videoCall }
})
export default class extends Vue {
    private videoCallVisible = false;

    created() {
      if (
      // eslint-disable-next-line no-prototype-builtins
        this.$route.query.hasOwnProperty('order_id') &&
        // eslint-disable-next-line no-prototype-builtins
        this.$route.query.hasOwnProperty('order_service_id')
      ) {
        this.videoCallVisible = true;
      }
    }

    videoCallClose() {

    }
}
